import { FC } from 'react';
import styles from './contentContainer.module.less';

const ContentContainer:FC = (props) => {
  const { children } = props;

  return (
    <div className={styles.contentContainer}>{children}</div>
  );
};

export default ContentContainer;
